import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiHelper } from 'cad/common/services/api/api-helper';
import { BusinessAssociateAssetContactApi } from 'cad/common/services/api/associate/business-associate/asset/contact/contact';

@Injectable()
export class AssociateBusinessAssociateAssetApi {

  private readonly endpoint: string = 'associate/business-associate/';
  private suffix: string = '/asset';

  constructor(
    public contact: BusinessAssociateAssetContactApi,
    private apiHelper: ApiHelper,
  ) {}

  public findAll = (id: string | number): Observable<any> => {
    return this.apiHelper.request(this.endpoint + id + this.suffix);
  }

  public save = (assetList: any[]): Observable<any> => {
    return this.apiHelper.request(this.endpoint + assetList[0].baId + this.suffix, { body: assetList });
  }
}
